import React, {useContext, useState} from 'react';
import classNames from 'classnames';
import AvatarImage from 'shared/components/avatar-image';
import {Menu, MenuItem} from '@mui/material';
import {map} from 'lodash';
import {PathDesignContext} from '../path-design-context';
import EllucianDrawer from '../ellucian/drawer';
import MobileNavbarMenuList from './MobileNavbarMenuList';
import NavbarLink from 'src/components/Navbar/NavbarLink/NavbarLink';
import {NavbarButtonProps} from 'src/components/Navbar/NavbarButton';
import {NavbarUserInfo} from './Navbar';
import styles from './styles.module.scss';

interface NavbarAvatarMenuProps {
  userInfo?: NavbarUserInfo | undefined;
  menuItems: NavbarButtonProps[];
  experienceEverywhere?: boolean;
}

const NavbarAvatarMenu = ({
  userInfo = {},
  menuItems,
  experienceEverywhere,
}: NavbarAvatarMenuProps) => {
  const path = useContext(PathDesignContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const handleMenuClose = (): void => {
    setAnchorEl(null);
  };

  const handleClick = (event): void => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }

    setOpen(true);
  };

  return (
    <>
      <button
        aria-label="Settings"
        aria-haspopup="true"
        onClick={handleClick}
        className={styles.avatarButton}
      >
        <AvatarImage
          userInfo={userInfo}
          aria-haspopup="true"
          className={classNames('menu', {
            light: experienceEverywhere,
            dark: !experienceEverywhere,
          })}
        />
      </button>
      {path.enabled ? (
        <EllucianDrawer open={open} anchor="right" onClose={() => setOpen(false)}>
          <MobileNavbarMenuList menus={menuItems} routed experienceEverywhere />
        </EllucianDrawer>
      ) : (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
          transformOrigin={{vertical: 'top', horizontal: 'right'}}
          transitionDuration={300}
          keepMounted
          elevation={1}
          PopoverClasses={{
            paper: styles.popover,
          }}
        >
          {map(menuItems, (item) => (
            <MenuItem
              key={item.path}
              aria-label={item.newTab ? `${item.title} (opens in a new tab)` : item.title}
              onClick={handleMenuClose}
              className={styles.menuItem}
              focusVisibleClassName={styles.menuItemFocus}
              disableRipple
            >
              <NavbarLink
                to={item.path}
                title={item.title}
                routed={item.routed}
                newTab={item.newTab}
              />
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default NavbarAvatarMenu;
